import Tooltip from '../Tooltip/Tooltip'
import classes from './PopoutButton.module.scss'
import { forwardRef } from 'react'
import type { ReactNode } from 'react'

export interface Props {
  onClick: () => void
  withTooltips?: boolean
  label: string
  children: ReactNode | ReactNode[]
}

const PopoutButton = forwardRef((
  {
    onClick,
    withTooltips = true,
    label,
    children
  }: Props,
  ref: any
) =>
  <button
    className={classes.PopoutButton}
    onClick={onClick}
    ref={ref}
    title={label}
    type='button'
  >
    {
      withTooltips
        ? (
          <Tooltip label={label}>
            {children}
          </Tooltip>
        )
        : children
    }
  </button>
)

export default PopoutButton
